import { cn } from "@/lib/utils";

const CHIP_VARIANTS = {
  green: "bg-fabrik-green-soft text-fabrik-accent-text",
  blue: "bg-fabrik-blue-soft text-fabrik-blue",
  orange: "bg-fabrik-orange-soft text-fabrik-orange",
  red: "bg-fabrik-red-soft text-fabrik-red",
  purple: "bg-fabrik-purple-soft text-fabrik-purple",
  gray: "bg-fabrik-gray-pill text-fabrik-text-2",
} as const;

export type ChipVariant = keyof typeof CHIP_VARIANTS;

export function Chip({
  variant = "gray",
  className,
  children,
}: {
  variant?: ChipVariant;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium",
        CHIP_VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
